import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">About Us</h3>
            <p className="text-sm mb-4">
              Your trusted source for professional industrial tools and equipment. We provide high-quality products for professionals and businesses.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-red-500 transition">
                <Facebook size={20} />
              </a>
              <a href="#" className="hover:text-red-500 transition">
                <Twitter size={20} />
              </a>
              <a href="#" className="hover:text-red-500 transition">
                <Instagram size={20} />
              </a>
              <a href="#" className="hover:text-red-500 transition">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products" className="hover:text-red-500 transition">
                  Shop All Products
                </Link>
              </li>
              <li>
                <Link to="/quotes" className="hover:text-red-500 transition">
                  Request Quote
                </Link>
              </li>
              <li>
                <Link to="/orders" className="hover:text-red-500 transition">
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/account" className="hover:text-red-500 transition">
                  My Account
                </Link>
              </li>
              <li>
                <Link to="/wishlist" className="hover:text-red-500 transition">
                  Wishlist
                </Link>
              </li>
              <li>
                <Link to="/compare" className="hover:text-red-500 transition">
                  Compare Products
                </Link>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Customer Service</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/contact" className="hover:text-red-500 transition">
                  Contact Us
                </Link>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition">
                  Shipping Information
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition">
                  Returns & Exchanges
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition">
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-red-500 transition">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>123 Industrial Way, Factory District, NY 10001</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={18} className="flex-shrink-0" />
                <span>800 060-0730</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={18} className="flex-shrink-0" />
                <span>support@industrialtools.com</span>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-sm font-semibold mb-2">Business Hours:</p>
              <p className="text-sm">Monday - Friday: 8:00 AM - 6:00 PM</p>
              <p className="text-sm">Saturday: 9:00 AM - 4:00 PM</p>
              <p className="text-sm">Sunday: Closed</p>
            </div>
          </div>
        </div>
      </div>

      {/* Features Bar */}
      <div className="bg-gray-800 border-t border-gray-700">
        <div className="container mx-auto px-4 py-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-center">
            <div>
              <div className="text-red-500 font-bold text-2xl mb-1">📦</div>
              <h4 className="font-semibold text-white mb-1">Free Shipping</h4>
              <p className="text-sm">For orders from $50</p>
            </div>
            <div>
              <div className="text-red-500 font-bold text-2xl mb-1">💬</div>
              <h4 className="font-semibold text-white mb-1">Support 24/7</h4>
              <p className="text-sm">Call us anytime</p>
            </div>
            <div>
              <div className="text-red-500 font-bold text-2xl mb-1">🔒</div>
              <h4 className="font-semibold text-white mb-1">100% Safety</h4>
              <p className="text-sm">Only secure payments</p>
            </div>
            <div>
              <div className="text-red-500 font-bold text-2xl mb-1">🔥</div>
              <h4 className="font-semibold text-white mb-1">Hot Offers</h4>
              <p className="text-sm">Discounts up to 70%</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-gray-950 border-t border-gray-800">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p>&copy; 2025 Industrial Tools. All rights reserved.</p>
            <div className="flex space-x-2 mt-2 md:mt-0">
              <span className="px-2 py-1 bg-gray-700 text-gray-300 text-xs font-semibold rounded">VISA</span>
              <span className="px-2 py-1 bg-gray-700 text-gray-300 text-xs font-semibold rounded">MC</span>
              <span className="px-2 py-1 bg-gray-700 text-gray-300 text-xs font-semibold rounded">AMEX</span>
              <span className="px-2 py-1 bg-gray-700 text-gray-300 text-xs font-semibold rounded">PayPal</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
